import { createClient } from '@supabase/supabase-js';

const url = process.env.RP_SUPABASE_URL;
const anonKey = process.env.RP_SUPABASE_ANON_KEY;

if (!url || !anonKey) {
  document.getElementById('root').innerHTML =
    '<p style="padding:40px;font-family:monospace">RP_SUPABASE_URL / RP_SUPABASE_ANON_KEY not set — check .env</p>';
  throw new Error('Missing Supabase env');
}

export const supabase = createClient(url, anonKey);

// เรียก RPC สะพาน public.rp_* — โยน error message ไทยจาก DB ตรงๆ
export async function rpc(fn, args) {
  const { data, error } = await supabase.rpc(fn, args);
  if (error) throw new Error(error.message || String(error));
  return data;
}

export async function view(name, build) {
  let q = supabase.from(name).select('*');
  if (build) q = build(q);
  const { data, error } = await q;
  if (error) throw new Error(error.message || String(error));
  return data || [];
}
